import { EmbedChannel } from '../channel'

export const sendChallengeOnCheckOrigin = (channel: EmbedChannel) => {
  channel.subscribe('check-origin', (event) => {
    if (event.challenge) {
      channel.send('check-origin', {
        challenge: event.challenge,
      })
    } else {
      channel.send('check-origin', {
        check: event.check, // legacy check-origin event
      })
    }
  })
}
